import {
  Alert,
  Button,
  Grid,
  MenuItem,
  Pagination,
  Paper,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { useState } from "react";
import { useTotalizadores } from "../../api/ESocialJTServiceApi";
import Page from "../../components/layout/page/Page";
import PageHeader from "../../components/page-header/PageHeader";
import { EstadoConsulta } from "../../components/operacional/Elementos";
import Totalizadores from "../../components/operacional/Totalizadores";
import { TOTALIZADORES } from "../../shared/apresentacaoEvento";
export function TotalizadoresConsulta() {
  const [form, setForm] = useState({ competencia: "", tipo: "", cpf: "" });
  const [filtros, setFiltros] = useState({});
  const [erro, setErro] = useState("");
  const query = useTotalizadores({ ...filtros, size: 10 });
  const field = (k) => ({
    value: form[k],
    onChange: (e) => setForm({ ...form, [k]: e.target.value }),
    size: "small",
    fullWidth: true
  });
  function buscar(e) {
    e.preventDefault();
    setErro("");
    if (!/^\d{4}(-(?:0[1-9]|1[0-2]))?$/.test(form.competencia))
      return setErro("Informe AAAA-MM ou AAAA para o 13º salário.");
    const cpf = form.cpf.replace(/\D/g, "");
    if (cpf && !/^\d{11}$/.test(cpf))
      return setErro("Informe um CPF com 11 dígitos.");
    setFiltros({ ...form, cpf, page: 0 });
  }
  return (
    <Stack spacing={2}>
      <Paper
        component="form"
        onSubmit={buscar}
        variant="outlined"
        sx={{ p: 2, borderRadius: 2 }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <TextField
              {...field("competencia")}
              required
              label="Competência"
              placeholder="2026-10 ou 2026"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField {...field("tipo")} select label="Tipo de totalizador">
              <MenuItem value="">Todos</MenuItem>
              {Object.entries(TOTALIZADORES)
                .filter(([t]) => t !== "5501")
                .map(([t, n]) => (
                  <MenuItem key={t} value={t}>
                    S-{t} · {n}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              {...field("cpf")}
              label="CPF"
              inputProps={{ maxLength: 14 }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={query.isFetching}
            >
              Consultar
            </Button>
          </Grid>
        </Grid>
        {erro && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            {erro}
          </Alert>
        )}
      </Paper>
      {filtros.competencia ? (
        <EstadoConsulta query={query}>
          {query.data?.content?.length ? (
            <>
              <Typography variant="body2" color="text.secondary">
                {query.data.totalElements} totalizadores locais · página{" "}
                {(filtros.page || 0) + 1}
              </Typography>
              <Totalizadores
                key={`${filtros.page}-${filtros.competencia}-${filtros.tipo}-${filtros.cpf}`}
                items={query.data.content}
              />
              <Pagination
                count={query.data.totalPages}
                page={(filtros.page || 0) + 1}
                onChange={(_, v) => setFiltros({ ...filtros, page: v - 1 })}
              />
            </>
          ) : (
            <Alert severity="info">
              Nenhum totalizador local encontrado. Isso não confirma a ausência
              de retorno no eSocial ou de entrega na Folha.
            </Alert>
          )}
        </EstadoConsulta>
      ) : (
        <Alert severity="info">
          Selecione uma competência para consultar os retornos armazenados no
          conector.
        </Alert>
      )}
    </Stack>
  );
}
export default function TotalizadoresPage() {
  return (
    <Page maxWidth="lg">
      <PageHeader
        primary="Totalizadores"
        secondary="Bases, contribuições, IRRF e FGTS com o contexto de cada retorno."
      />
      <TotalizadoresConsulta />
    </Page>
  );
}
